import { useEffect, useState } from "react"
import SidebarComponent from "../Component/SidebarComponent"
import HeaderComponent from "../Component/HeaderComponent"
import ListProducts from "../Component/Product/ListProducts"
import CreateProduct from "../Component/Product/CreateProduct"
import { useLocation } from "react-router-dom"

const ProductPage = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const  [showListProducts,setShowListProducts] = useState(true)
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
        
        if(searchParams.has('productId')) {
            setShowListProducts(false);
        }
    },[]);
    return (
        <div className="flex w-full h-full min-h-screen pb-[15px] bg-[#171717]">
            <SidebarComponent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className={`${sidebarOpen?'md:ml-[250px]' : 'md:ml-[100px]'}  text-white w-full  md:mt-8`}>
                <HeaderComponent setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} title={'Produtos'} subTitle={'Seja bem-vindo ao painel de controle da sua empresa'} />
                {showListProducts && <ListProducts setShowListProducts={setShowListProducts}/> }
                {!showListProducts && <CreateProduct setShowListProducts={setShowListProducts}/>}
            </div>
        </div>
    )
}

export default ProductPage